import { useCallback, useEffect, useRef, useState } from 'react';
import { Confirm } from 'ui/icons/action/Confirm';
import { MakeCopy } from 'ui/icons/action/MakeCopy';
import { CopyToClipboard } from './CopyToClipboard';
import {
  ContentContainer,
  ContentButtonArea,
  ContentText,
  ContentCopyToClipboardButton,
} from './Styled';
import { GraphQLSnippet } from '../types';
import { generateSlug } from '../utils';

type Props = {
  snippet: GraphQLSnippet;
};

export const SnippetContentCell = ({ snippet }: Props) => {
  const [isCopied, setIsCopied] = useState(false);
  const copiedTimer = useRef<ReturnType<typeof setTimeout>>();
  const snippetSlug = generateSlug(snippet.name, snippet.positionalParameters);

  // Show 'copied' indicator, then revert after 3 seconds
  const onCopy = useCallback(() => {
    if (copiedTimer.current) {
      clearTimeout(copiedTimer.current);
    }
    setIsCopied(true);
    copiedTimer.current = setTimeout(() => {
      setIsCopied(false);
    }, 3000);
  }, []);

  useEffect(() => {
    return () => {
      if (copiedTimer.current) {
        clearTimeout(copiedTimer.current);
      }
    };
  }, []);

  return (
    <CopyToClipboard text={snippetSlug} onCopy={onCopy}>
      <ContentContainer>
        <ContentCopyToClipboardButton data-test="copy-to-clipboard-button">
          {isCopied ? <Confirm isColorInherited={true} /> : <MakeCopy width={16} height={16} />}
          <div>{isCopied ? 'Copied' : 'Copy'}</div>
        </ContentCopyToClipboardButton>
        <ContentText>
          <span>{snippetSlug}</span>
        </ContentText>
        <ContentButtonArea />
      </ContentContainer>
    </CopyToClipboard>
  );
};
